/**
 * FixedProjectImage
 * A full-viewport project image that stays fixed in the viewport while the
 * sections above and below scroll over it. Achieved by giving the section
 * a large scroll height and pinning the image with position:fixed inside a
 * sticky/relative wrapper. The sections above and below use their normal
 * background colors, so as they scroll they "cover" the fixed image.
 *
 * Accepts optional props so the same component can be reused for multiple
 * selected-project moments on the homepage.
 */
import { PROJECT_IMAGE } from "@/constants/assets";

export const FixedProjectImage = ({
  image = PROJECT_IMAGE,
  eyebrow = "— Selected Project",
  id = "project-image",
  testid = "fixed-project-image",
}) => {
  return (
    <section
      id={id}
      data-testid={testid}
      className="relative h-[120vh] w-full overflow-hidden bg-black"
    >
      <div
        aria-label={`Featured Eurosteel project — ${image.title}`}
        role="img"
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(${image.src})`,
          backgroundAttachment: "fixed",
        }}
      />
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black/30" />
    </section>
  );
};
